import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { TwoFactorAuthVerify } from '@components/templates/authentication/twoFactorAuthVerify';

export function TwoFactorAuthVerifyPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('two-factor-authentication-component.metatags.title'),
        description: t('two-factor-authentication-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.twoFactorAuthVerify,
        index: false,
    });

    return <TwoFactorAuthVerify />;
}
